export const pillars = ['Prevention', 'Daily Care', 'Nutrition', 'Safety', 'Wellness'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'The Sharp Mind Protocol',
  desc: 'Understand how cognitive health actually works and step by step, so you can assess memory, prevent confusion and maintain mental clarity — even if you have never managed cognitive decline before.'
}, {
  n: 2,
  emoji: '📗',
  title: 'Mobility Without Fear',
  desc: 'Learn to maintain strength, prevent falls, manage balance and keep your parent mobile with progressive exercise protocols, avoiding the most common mistakes families make when prescribing senior fitness.'
}, {
  n: 3,
  emoji: '📙',
  title: 'The Expert Care Companion',
  desc: "Incorporate the complete protocol for managing Alzheimer's, Parkinson's, Diabetes and Hypertension with clear progression criteria and daily management so you can handle complex conditions in real situations from day one."
}, {
  n: 4,
  emoji: '📕',
  title: 'The 360° Vital Log',
  desc: 'Follow an organized system to track blood pressure, blood sugar, medications, sleep and vital signs with concrete measurement points to advance without getting lost and detect early warning signs before they become emergencies.'
}, {
  n: 5,
  emoji: '📓',
  title: 'The Empowered Caregiver',
  desc: 'By the end of this volume you will understand caregiver burnout, mental health maintenance and self-care so completely that you can build sustainable wellness protocols for yourself without guilt or exhaustion.'
}, {
  n: 6,
  emoji: '📔',
  title: 'The Independence Adaptation',
  desc: 'Make real clinical decisions, manage daily activities with dignity, adapt your home for safety and have your first complete independence protocol in place without freezing or second-guessing your progressions.'
}];
export const volumeIncludes = ['Visual step-by-step protocols', 'Assessment criteria + translation', 'Progression checkpoints', 'Real daily-life examples', 'Weekly tracking checklists', 'Printable care sheets', 'Designed for absolute beginners and caregivers', 'Ready to apply from today'];
export const bonuses = [{
  n: '01',
  title: 'The Smart-Kitchen Guide 60+',
  desc: "The definitive nutrition protocol to fuel brain health and longevity. Includes neuro-protective meal plans and anti-inflammatory recipes to keep them sharp and energized.",
  price: '$47',
  cover: 'https://cdn.magicpatterns.com/uploads/jyeWbCGkQAtev1PcBeurdv/BONO_1.png'
}, {
  n: '02',
  title: 'The Legacy Binder',
  desc: 'A guide to family connection, life story preservation and emotional health. Includes 30 interview questions, memory activation techniques, social engagement strategies and wisdom transfer templates. Perfect for deepening bonds and preventing isolation-related decline.',
  price: '$37',
  cover: 'https://cdn.magicpatterns.com/uploads/7umo9kPjii67K9zRsRdo4i/BONO_2.png'
}, {
  n: '03',
  title: 'The Fall-Proof Home Audit',
  desc: 'A professional checklist to transform your home into a senior fortress. Room-by-room risk assessment, low-cost modifications, lighting protocols and safety systems. Perfect for preventing the #1 cause of senior hospitalization: falls.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/a8gcySf9i5LVu3d3YQw2xv/BONO_3.png'
}, {
  n: '04',
  title: 'The 5-Minute Caregiver Relief',
  desc: 'Rapid strategies to prevent burnout and reclaim your mental peace. Includes breathing techniques, micro-meditations, stress management protocols and self-care systems. Perfect for keeping YOU healthy while caring for your parent.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/fBPSzEUX4EzLLJU466uACv/BONO_4.png'
}, {
  n: '05',
  title: 'The Emergency Responder Dashboard',
  desc: 'A command system for medical crisis readiness. Includes medication passport, vital signs tracker, emergency protocols and first-aid procedures specific to seniors. Perfect for having clarity when seconds count.',
  price: '$17',
  cover: 'https://cdn.magicpatterns.com/uploads/fLePTd8fWRQxcZV9kiSX8w/BONO_5.png'
}];